import { Search } from "@/search/search";

export interface ISearchService {
    getFilteredData(filter: string, list: Array<any>): Array<any>;
    getFilteredSearch(filter: string, search: Search): Array<any>;
}

export class SearchService implements ISearchService {
    public getFilteredData(filter: string, list: Array<Object>): Array<any> {
        return list.filter(item => {
            return Object.values(item).some(val =>
                String(val).includes(filter)
            );
        });
    }

    public getFilteredSearch(filter: string, search: Search): Array<any> {
        if (search.list == null) return [];
        
        return search.list.filter(item => {
            //console.log(Object(item).uuid);
            
            if (String(Object(item).uuid).toLowerCase().includes(filter) 
                || String(Object(item).businessName).toLowerCase().includes(filter)
                || String(Object(item).groupName).toLowerCase().includes(filter))
            {
                return Object.values(item);
            }
            
        }); 
        
    }

    public getFilteredSearchByBusiness(filter: string, search: Search): Array<any> {
        if (search.list == null) return [];
        
        return search.list.filter(item => {
            //console.log(Object(item).uuid);
            
            if (String(Object(item).uuid).toLowerCase().includes(filter)
                || String(Object(item).groupName).toLowerCase().includes(filter))
            {
                return Object.values(item);
            }
            
        }); 
        
    }

    public getFilteredSearchByUuid(filter: string, search: Search): Array<any> {
        if (search.list == null) return [];
        
        return search.list.filter(item => {
            //console.log(Object(item).uuid);
            
            if (String(Object(item).uuid).toLowerCase().includes(filter) 
                || String(Object(item).name).toLowerCase().includes(filter))
            {
                return Object.values(item);
            }
            
        }); 
        
    }

    public getFilteredSearchByNumber(filter: string, search: Search): Array<any> {
        if (search.list == null) return [];
        
        return search.list.filter(item => {
            //console.log(Object(item).uuid);
            
            if (String(Object(item).phoneNumber).toLowerCase().includes(filter))
            {
                return Object.values(item);
            }
            
        }); 
        
    }

    public getFilteredSearchByEmail(filter: string, search: Search): Array<any> {
        if (search.list == null) return [];
        
        return search.list.filter(item => {
            //console.log(Object(item).uuid);
            
            if (String(Object(item).uuid).toLowerCase().includes(filter) 
                || String(Object(item).emailAddress).toLowerCase().includes(filter))
            {
                return Object.values(item);
            }
            
        }); 
        
    }
}
